var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": _vm.header, role: "dialog", size: "lg" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.header)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "pillars-instructions" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.instructions) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pillars-container" }, [
            _c(
              "div",
              { staticClass: "pillars-scroll-area" },
              _vm._l(_vm.goalPillars, function (pillar, pillarId) {
                return _c(
                  "div",
                  { key: pillarId, staticClass: "checkbox pillar-item" },
                  [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedPillars[pillarId],
                            expression: "selectedPillars[pillarId]",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.selectedPillars[pillarId])
                            ? _vm._i(_vm.selectedPillars[pillarId], null) > -1
                            : _vm.selectedPillars[pillarId],
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.selectedPillars[pillarId],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.selectedPillars,
                                    pillarId,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.selectedPillars,
                                    pillarId,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.selectedPillars, pillarId, $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pillar-details" }, [
                        _c("strong", { staticClass: "pillar-title" }, [
                          _vm._v(_vm._s(pillar.title)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pillar-description" }, [
                          _vm._v(_vm._s(pillar.description)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pillar-subtitle" }, [
                          _vm._v(_vm._s(pillar.subtitle)),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-6 text-left" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-default save-button",
                on: {
                  click: function ($event) {
                    return _vm.close("back")
                  },
                },
              },
              [
                _c("i", { staticClass: "far fa-chevron-left" }),
                _vm._v(" back\n                "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-green save-button",
                on: { click: _vm.ok },
              },
              [_vm._v("\n                    Next\n                ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }